import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { logout } from "store/apps/auth";

export function useNavMobile() {
  const { user } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  const _onLogout = () => {
    dispatch(logout());
  };

  return { isLoggedIn: user != null, _onLogout };
}
